<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
    <z-page title="Carian Laporan DAYABIAK PEJANTAN (BSE)">
      <div class="table_scrol">
         <div class="w-card__content content-hardcode mb3">
          <w-form v-model="valid" @validate="cari" ref="frm">
                <w-flex class="mt3 filter-row">
                    <div class="filter-col">
                      <!-- <z-select style="margin:5px; " v-model="pencarian.premis_id" :items="premis" label="ID Premis" /> -->
                        <z-select style="margin:5px;" :items="negeri" label="Negeri"  v-model="pencarian.lkp_negeri_id" @input="getBandar(pencarian.lkp_negeri_id)" />
                    </div>
                    <div class="filter-col">
                        <z-select style="margin:5px;" :items="bandar" class="mt4" label="Daerah"  v-model="pencarian.lkp_bandar_id" />
                    </div>
                    <div class="filter-col">
                        <w-select style="margin:5px;"
                              :items="lkp_baka" 
                              label="Baka"  
                              v-model="pencarian.lkp_baka_id" 
                            />
                    </div>
                </w-flex>

                <w-flex class="mt3 filter-row">
                    <div class="filter-col">
                         <w-select style="margin:5px;"
                              :items="lkp_tujuan" 
                              label="Tujuan BSE"  
                              v-model="pencarian.lkp_tujuan_id" 
                            /> 
                    </div>
                    <div class="filter-col">
                        <w-select style="margin:5px;"
                            :items="lkp_ternakan" 
                            label="Jenis Ternakan" 
                            v-model="pencarian.lkp_ternakan_id" 
                            @input="getJurusan(pencarian.lkp_ternakan_id)"
                          />
                    </div>
                    <div class="filter-col">
                        <w-select style="margin:5px;"
                              :items="lkp_jurusan" 
                              label="Jurusan Ternakan"  
                              v-model="pencarian.lkp_jurusan_id" 
                              @input="getBakaCarian(pencarian.lkp_jurusan_id)" 
                        />
                    </div>
                </w-flex>
                <w-flex class="mt3 filter-row">
                    <div class="filter-col">
                        <w-input 
                            label="Tarikh Pemeriksaan Dari" 
                            type="date" 
                            v-model="pencarian.tarikh_pemeriksaan_dari"
                        />
                    </div>
                    <div class="filter-col">
                        <w-input 
                            label="Tarikh Pemeriksaan Hingga" 
                            type="date" 
                            v-model="pencarian.tarikh_pemeriksaan_hingga"
                        />
                    </div>
                    <div class="filter-col">
                    </div>
                </w-flex>
          </w-form>
          <br>
          <w-flex justify-end class="mt2">
              <w-button class="mr2" v-on:click="resetPencarian()" bg-color="warning">
                  <w-icon>fal fa-redo</w-icon>&nbsp;SET SEMULA</w-button>
              <w-button class="mr2" bg-color="primary" @click="$refs.frm.validate()">
                  <w-icon>fal fa-search</w-icon>&nbsp;CARI
              </w-button>
          </w-flex>
        </div>
         <w-card title-class="blue-dark4--bg white" style="font-size: 13px;" :title="'SENARAI LAPORAN PROGRAM PEMERIKSAAN DAYABIAK PEJANTAN (BSE)'">
          <template #title>
            SENARAI LAPORAN PROGRAM PEMERIKSAAN DAYABIAK PEJANTAN (BSE)
          </template>
            <w-flex justify-end class="mt2">
                <w-button bg-color="success" v-on="on" @click="createExcel()" class="mr2">
                    <w-icon class="mr1" md >fal fa-download</w-icon>Muat Turun Excel
                </w-button>
            </w-flex>
            <br>
          <div class="w-table-wrap" style="max-height: 900px;">
            
            <div class="table-profil-scrol">
              <br><br>
              <table class="w-table" color="light" style="border:1px" width="100%">
                <thead>
                  <tr class="w-table__header text-center" style="border: 1px solid #000;">
                    <th class="w-table__header text-center" rowspan="2" style="border:1px solid #000;">BIL</th>
                    <th class="w-table__header text-center" rowspan="2" style="border:1px solid #000;">Negeri</th>
                    <th class="w-table__header text-center" rowspan="2" style="border:1px solid #000;">Daerah</th>
                    <th class="w-table__header text-center" rowspan="2" style="border:1px solid #000;">Nama Penternak</th>
                    <th class="w-table__header text-center" rowspan="2" style="border:1px solid #000;">ID / Nama Premis</th>
                    <th class="w-table__header text-center" rowspan="2" style="border:1px solid #000;">Tarikh Pemeriksaan</th>
                    <th class="w-table__header text-center" rowspan="2" style="border:1px solid #000;">No Permohonan</th>
                    <th class="w-table__header text-center" rowspan="2" style="border:1px solid #000;">Tujuan BSE</th>
                    <th class="w-table__header text-center" colspan="6" style="border:1px solid #000; background:#f5d6c6;">Maklumat Ternakan</th>
                    <th class="w-table__header text-center" colspan="3" style="border:1px solid #000; background:#d6e4f5;">Pemeriksaan Fizikal</th>
                    <th class="w-table__header text-center" colspan="4" style="border:1px solid #000; background:#f5d6c6;">Pemeriksaan Musculoskeletal</th>
                    <th class="w-table__header text-center" colspan="8" style="border:1px solid #000; background:#d6e4f5;" >Analisa Kualiti Semen Dan Spermatozoa</th>
                    <th class="w-table__header text-center" colspan="6" style="border:1px solid #000; background:#f5d6c6;">Pemeriksaan Organ Genital Luaran</th>
                    <th class="w-table__header text-center" colspan="3" style="border:1px solid #000; background:#d6e4f5;">Pemeriksaan Organ Genital Dalaman</th>
                    <th class="w-table__header text-center" colspan="6" style="border:1px solid #000; background:#f5d6c6;">Status Pemeriksaan Penyakit</th>
                    <th class="w-table__header text-center" rowspan="2" style="border:1px solid #000; ">Status Pemeriksaan</th>

                  </tr>
                  <tr class="w-table__header text-center" style="border: 1px solid #000;">
                    <th class="w-table__header text-center" style="border:1px solid #000;">No Pendaftaran</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">ID Ternakan</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Nama Ternakan</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Jenis Ternakan</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Jurusan Ternakan</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Baka</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Skor Badan</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Berat</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Tanda Klinikal Penyakit</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Locomotor</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Postur Kaki</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Postur Badan</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Pemeriksaan Libido</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Kaedah Pungutan Semen</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Isipadu</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Warna</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Kepekatan x10⁶ (/ml)</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Skor Massa</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Motiliti Hidup</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Motiliti Progresif</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Kecacatan</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Testis</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Epididymis</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Korda Spermatik</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Prepuce / Penis</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Skor Kekenyalan Testis</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Ukurlilit Skortum</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Ampullae</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Kelenjar Vesikal</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Kelenjar Prostat</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Brucellosis</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">FMD</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Trichomoniasis</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Campylobacteriosis</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Leptospirosis</th>
                    <th class="w-table__header text-center" style="border:1px solid #000;">Tuberculosis</th>
                  </tr>
                </thead>
                <tbody>
                    <template v-if="items.data.length == 0">
                        <tr class="w-table__row" >
                            <td class="w-table__cell text-left" colspan="44"> Tiada Data.</td>
                        </tr>
                    </template>
                  <template  v-for="(dt, ind) in items.data" :key="dt.id">
                    <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">
                        {{ (items.current_page - 1) * items.per_page + ind + 1 }}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.negeri ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.daerah ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_penternak ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_premis ?? '-'}} / {{dt.nama_premis ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.tarikh_pemeriksaan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_permohonan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.tujuan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.no_pendaftaran ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.id_ternakan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.nama_ternakan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jenis_ternakan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.jurusan_ternakan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.baka_ternakan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.skor_badan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.berat ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.tanda_klinikan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.locomotor ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kaki ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.badan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.skor_libido ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kaedah ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.isipadu ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.warna ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kepekatan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.motiliti ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.motiliti_hidup ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.motiliti_progresif ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kecacatan ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.testis ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.epididymis ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.korda ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.penis ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.kekenyalan_testis ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.skortum ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.ampullae ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.vesikal ?? '-'}}</td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.prostat ?? '-'}}</td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                          {{ getPenyakitStatus(dt, 'Brucellosis')  ?? '-'}}
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                          {{ getPenyakitStatus(dt, 'FMD')  ?? '-'}}
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                          {{ getPenyakitStatus(dt, 'Trichomoniasis')  ?? '-'}}
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                          {{ getPenyakitStatus(dt, 'Campylobacteriosis')  ?? '-'}}
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                          {{ getPenyakitStatus(dt, 'Leptospirosis')  ?? '-'}}
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000;">
                          {{ getPenyakitStatus(dt, 'Tuberculosis')  ?? '-'}}
                        </td>
                        <td class="w-table__cell text-left" style="border: 1px solid #000;">{{dt.status_pemeriksa ?? '-'}}</td>
                    </tr>
                  </template>

                    <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: none;" colspan="39">
                           &nbsp;
                        </td>
                    </tr>
                    <tr class="w-table__row">
                        <td class="w-table__cell text-left" style="border: 1px solid #000; background:#d6e4f5;" colspan="10">
                           JUMLAH KESELURUHAN TERNAKAN DIBUAT BSE (EKOR)
                        </td>
                        <td class="w-table__cell text-center" style="border: 1px solid #000; background:#d6e4f5;" colspan="3">
                           {{jumlah_keseluruhan}}
                        </td>
                    </tr>
                </tbody>
              </table>
              <br><br>
            </div>
          </div>
          <table style="border:none;" width="100%">
                <tbody>
                    <tr>
                        <td style="border: none; " width="75%" >
                            <div class="per-page-control">
                                <label for="perPage" class="per-page-label">Rekod per halaman : </label>
                                <select v-model="perPage" @change="changePerPage" id="perPage" class="per-page-select">
                                    <option v-for="opt in perPageOptions" :key="opt" :value="opt">
                                       {{ opt }}
                                    </option>
                                </select>
                            </div>
                        </td>
                        <td style="border: none; " width="25%"  align="right">
                            <nav class="pagination">
                              <button
                              class="pagination-btn"
                              :disabled="!items.prev_page_url"
                              @click="paginate(items.prev_page_url)"
                              >
                                Sebelumnya 
                              </button>

                              <span class="pagination-info">
                                {{ items.current_page }} dari {{ items.last_page }}
                              </span>
                             

                              <button
                              class="pagination-btn"
                              :disabled="!items.next_page_url"
                              @click="paginate(items.next_page_url)"
                              >
                                Seterusnya
                              </button>
                            </nav>
                        </td>
                    </tr>
                </tbody>
            </table>
        </w-card>

       <!--   <z-table title="Senarai Permohonan Baka" :headers="table.headers" :items="table.items" :meta="table.meta" :mobile-breakpoint="700">
         </z-table>
 -->

      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
    jumlah_keseluruhan: Number,
    segmenName: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'laporan.bse'+this.segmenName,
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Laporan KPI', route: '/laporan' },
        { label: 'Dayabiak Pejantan (BSE)', route: 'laporan/bse' },
      ],
      // perPage: this.$page.props.items?.per_page || 1,
      form : this.datas,
      

      pencarian: {
         lkp_negeri_id: '',
         lkp_bandar_id: '',
         lkp_jenis_baka_id: '',
         lkp_ternakan_id: '',
         lkp_jurusan_id: '',
         lkp_baka_id: '',
         lkp_tujuan_id: '',
         tarikh_pemeriksaan_dari: '',
         tarikh_pemeriksaan_hingga: '',
      },
      premis: [],
      negeri:[],
      bandar:[],
      lkp_jurusan :[],
      lkp_baka :[],
      lkp_ternakan : [],
      lkp_tujuan : [],


      perPageOptions: [5, 10, 50, 99],
      perPage: this.items.per_page || 10,
      
      
    }
  },
  methods: {
    paginate(url) {
    this.$inertia.get(url, {}, {
      preserveState: true,
      preserveScroll: true,
    });
    },

    changePerPage() {
            let params = {
                ...this.pencarian,
                per_page: this.perPage,
                page: 1
            };
            this.$inertia.visit(route(route().current(), params), {
                preserveState: true,
                preserveScroll: true,
            });
        },

   
   cari() {
       if(!this.valid) return;

       let params = {
       ...this.pencarian,
       };
       params.page = 1;
       this.$inertia.visit(route(route().current(), params), {
           preserveState: true,
           preserveScroll: true,
       });
    },

    resetPencarian() {
       this.$inertia.visit(route(route().current()));
    },

    getPremis(){
     this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
       this.premis = res
     })
   },
   getJenisBaka(){
      this.$zcomm.get(this.api_service + 'lookup/jenis_baka', {}).then(res => {
        this.lkp_jenis_baka = res
      })
    },

   getNegeri() {
     this.$zcomm.get(this.api_service + 'lookup/negeri_user', {}).then(res => {
       this.negeri = res

       
       if (this.negeri.length === 1) {
         this.selectedNegeri = this.negeri[0].value
         this.getBandar(this.selectedNegeri)
       }
     })
   },

   getBandar(i){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+i, {}).then(res => {
          this.bandar = res
        })
      },

    getTernakan(){
         this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
           this.lkp_ternakan = res
         })
       },

    getJurusan(i){
         this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
           this.lkp_jurusan = res
         })
       },

    getBakaCarian(i){
         this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
           this.lkp_baka = res
         })
       },

    getTujuan(){
         this.$zcomm.get(this.api_service + 'lookup/tujuan', {}).then(res => {
           this.lkp_tujuan = res
         })
       },

    getPenyakitStatus(dt, penyakitName) {
    if (!dt.penyakit) return '-';
    const penyakit = dt.penyakit.find(p => p.nama === penyakitName);
    return penyakit ? penyakit.status : '-';
  },
   createExcel() {
    const params = {
         lkp_negeri_id: this.pencarian.lkp_negeri_id || '',
         lkp_bandar_id: this.pencarian.lkp_bandar_id || '',
         lkp_jenis_baka_id: this.pencarian.lkp_jenis_baka_id || '',
         lkp_ternakan_id: this.pencarian.lkp_ternakan_id || '',
         lkp_jurusan_id: this.pencarian.lkp_jurusan_id || '',
         lkp_baka_id: this.pencarian.lkp_baka_id || '',
         lkp_tujuan_id: this.pencarian.lkp_tujuan_id || '',
         tarikh_pemeriksaan_dari: this.pencarian.tarikh_pemeriksaan_dari || '',
         tarikh_pemeriksaan_hingga: this.pencarian.tarikh_pemeriksaan_hingga || '',
         excel: 1 // penanda untuk generate Excel
      };

      const queryString = new URLSearchParams(params).toString();
      const url = route('kpi.bse') + '?' + queryString;

    // const url = route('laporan.anak.ai') + '?' + new URLSearchParams(params).toString();

    window.open(url, '_blank');
  }




  },

  watch: {

  },

  mounted() {
   this.getPremis();
   this.getJenisBaka();
   this.getNegeri(); 
   this.getTernakan();
   // this.getJurusan();
   // this.getBakaCarian();
   this.getTujuan();
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>

<style>
.pagination {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 1rem;
}

.pagination-btn {
  background-color: #007bff;
  color: white;
  padding: 5px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.pagination-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination-info {
  font-weight: bold;
}

.w-table thead tr:nth-child(1) th {
  position: sticky;
  top: 2px;
  background: #fff;
  z-index: 3;
}

/* Header baris kedua */
.w-table thead tr:nth-child(2) th {
  position: sticky;
  top: 45px; /* sesuaikan dengan tinggi row pertama */
  background: #fff;
  z-index: 2;
}

.role-selector {
  width: 100%;
  max-width: 400px;
  border: 2px solid #1976d2;
  border-radius: 8px;
  background-color: #f5f5f5;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-weight: bold;
}

.role-selector .w-select__selection {
  padding: 12px 16px;
  font-size: 16px;
}

.role-selector .w-select__label {
  font-weight: bold;
  color: #1976d2;
}
.filter-row {
  display: flex;
  gap: 10px;
}

.filter-col {
  flex: 1;
  min-width: 220px; /* optional – elak jadi terlalu kecil */
}
</style>
